export const environment = {
	production: true,
	applicationServerPublicKey: `BKs-gr4Ax565YXCxSgqOvO9O19zQUG_P5vAz_bfhiamTRQNqFeT1wUtHX4cL4JX3oG8x8HCo5P0pIYzmOZ3eitQ`
};
